import './Details.css';
import { FiUser } from "react-icons/fi";
import { FaLocationDot, FaCarSide, FaBuildingColumns } from "react-icons/fa6";
import { MdDateRange, MdOutlineCall, MdOutlineMailOutline } from 'react-icons/md';
import NotesSection from './NotesSection';
import React from 'react';
import { FiEye, FiDownload, FiTrash2 } from 'react-icons/fi';
import { ClientDetailsLogic } from './ClientDetailsLogic';
import EditReferralModal from '../AddReferralModal/EditReferralModal';
import { LuFiles, LuLogs } from 'react-icons/lu';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import Zohomodel from './Zohomodel';
import { FaUserCircle } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";


function ClientDetails() {
  // Call the logic hook to get all the necessary state and functions
  const {
    editSection, setEditSection, isModalOpen, setIsModalOpen, client,
    isDragging, navigate, files,
    fileInputRef, logsList, showLogs, fetchByReferralData, handleToggleLogs,
    handleFileChange, handleDragOver, handleDragLeave, handleDrop,
    handlePreview, handleDownload, handleDelete, handleStatusChange,
    accessLevel, isPreviewable, handleToggleFiles, showFilesTable, fetchReferralZohoData, openFolder, closeModal, showModal,
    handleCreateReferral, handleLinkToZoho, zohoData
  } = ClientDetailsLogic();

  if (!client) {
    return <p className="error">Client data not found</p>;
  }


  return (
    <div className="main-content">
      <button className="back-button" onClick={() => navigate('/')}>← Back to Referrals</button>

      <div className="client-header">
        <h2 className="client-name">
          {client.firstName} {client.middleName} {client.lastName}
        </h2>

        <p className="select-text">
          <span className="status-label">Status:</span>
          {accessLevel === 2 || accessLevel === 3 ? (
            <select
              value={client.status}
              onChange={(e) => handleStatusChange(e.target.value)}
              className="status-select"
            >
              <option value="Pending">Pending</option>
              <option value="Unable to reach client">Unable to reach client</option>
              <option value="Install Scheduled">Install Scheduled</option>
              <option value="Install Complete">Install Complete</option>
              <option value="Sale Not Made">Sale Not Made</option>
              <option value="Customer Requested More Time">Customer Requested More Time</option>
            </select>
          ) : (
            <span className="static-status">{client.status}</span>
          )}
        </p>
        <div className="status-wrapper">
          {(accessLevel === 3 || accessLevel === 2) && (
            <div className="client-status">
              {client.isInfoUploadedToZoho === 0 ? (
                <button
                  className="right-btn"
                  onClick={fetchReferralZohoData}
                >
                  Send to Zoho
                </button>
              ) : client.isInfoUploadedToZoho === 1 ? (
                <span className="zoho-status green">
                  Successfully sent to Zoho Sharks.
                </span>
              ) : client.isInfoUploadedToZoho === 2 ? (
                <span className="zoho-status blue">
                  Already exists & linked with Zoho Sharks.
                </span>
              ) : client.isInfoUploadedToZoho === 3 ? (
                <span className="zoho-status-orange">
                  Referral already exists but has been added as a new referral in Zoho Shark.
                </span>
              ) : null}
            </div>
          )}
        </div>
      </div>
      <div className="details-layout">
        <div className="left-column">
          <div className="card-row">
            <div className="card card-details">
              <div className="info-header">
                <span className='users-icon'><FiUser size={20} className='users-icon' /> Personal Information</span>
                <button
                  className="edit-info-btn"
                  onClick={() => {
                    setEditSection('personal');
                    setIsModalOpen(true);
                  }}
                >
                  Edit
                </button>
              </div>
              <div className="info-columns">
                <div className="left-col">
                  <p><span className="fullnameinfo ">{client.firstName} {client.middleName} {client.lastName}</span></p>
                  <p><MdOutlineMailOutline size={16} /> {client.email}</p>
                  <p><MdDateRange size={16} className='emergency-icon' /> DOB: {client.dob || '-'}</p>
                </div>
                <div className="right-col">
                  <p><MdOutlineCall size={16} className='emergency-icon' /> {client.phoneNumber}</p>
                  <p><MdOutlineCall size={16} className='emergency-call emergency-icon' /> {client.emergencyPhone || '-'}</p>
                  {(accessLevel === 3 || accessLevel === 2) && (
                  <p>
                    <span className='emergency-call-1 emergency-icon-1'>Referral Added By :</span>
                    <span style={{ marginLeft: '6px' }}>
                      {client.referralAddedBy
                        ? client.referralAddedBy
                          .split('@')[0]
                          .split('.')
                          .join(' ')
                        : '-'}
                    </span>
                  </p>
                   )}
                </div>
              </div>
            </div>

            <div className="card card-details mt-3">
              <div className="info-header">
                <span className='users-icon'><FaLocationDot size={20} /> Address Information</span>
                <button
                  className="edit-info-btn"
                  onClick={() => {
                    setEditSection('address');
                    setIsModalOpen(true);
                  }}
                >
                  Edit
                </button>
              </div>
              <p>{client.address}</p>
              <p>{client.city}, {client.county} {client.state} {client.zip}</p>
            </div>
          </div>

          <div className="card-row">
            <div className="card card-details">
              <div className="info-header">
                <span className='users-icon mb-2'><FaCarSide size={20} /> Vehicle Information</span>
                <button
                  className="edit-info-btn"
                  onClick={() => {
                    setEditSection('vehicle');
                    setIsModalOpen(true);
                  }}
                >
                  Edit
                </button>
              </div>

              <div className="vehicle-grid">
                <div className="vehicle-item">
                  <strong>Make : </strong>
                  <span>{client.vehicleMake || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>Model :</strong>
                  <span>{client.vehicleModel || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>Year :</strong>
                  <span>{client.vehicleYear || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>Color :</strong>
                  <span>{client.vehicleColor || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>VIN :</strong>
                  <span>{client.vin || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>Driver's License Number :</strong>
                  <span>{client.DriverlicenseNumber || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>License Plate :</strong>
                  <span>{client.licensePlate || '-'}</span>
                </div>
                <div className="vehicle-item">
                  <strong>Ignition Type :</strong>
                  <span>{client.ignitionType || '-'}</span>
                </div>
              </div>
            </div>
            <div className="card card-details mt-3 hover-group">
              <div className="info-header ">
                <span className='users-icon'><FaBuildingColumns size={18} className='users-icon' /> Court Information</span>
                <button
                  className="edit-info-btn"
                  onClick={() => {
                    setEditSection('court');
                    setIsModalOpen(true);
                  }}
                >
                  Edit
                </button>
              </div>
              <p>{client.courtName || '-'}</p>
              <span className='users-icon-1'><MdLocationPin size={14} className='users-icon-1' /> {client.courtAddress || '-'}</span>
  

            </div>
            {(accessLevel === 2 || accessLevel === 3) && (
              <div className="card card-details uploaded-files-table">
                <div className="info-header mb-3 log-toggle-header" onClick={handleToggleLogs}>
                  <span className="log-section-header ">
                    <span className="log-title">
                      <LuLogs size={20} /> Logs
                    </span>
                    <div className="toggle-icon">
                      {showLogs ? <FaAngleUp size={20} /> : <FaAngleDown size={20} />}
                    </div>
                  </span>
                </div>
                {showLogs && (
                  <div className='uploaded-files-table-1'>
                    <table>
                      <thead>
                        <tr>
                          <th>SL.NO</th>
                          <th>Description</th>
                          <th>Timestamp</th>
                        </tr>
                      </thead>
                      <tbody>
                        {logsList.length > 0 ? (
                          logsList.map((log, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{log.Description}</td>
                              <td>{new Date(log.AddedTimeStamp).toLocaleString()}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No logs available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="right-column">
          <div className="card card-details">
           
            <NotesSection
              initialNotes={(client?.notes || []).map(note => note.text)}
              referralID={client?.referralID}
              fetchReferralData={fetchByReferralData}
            />
          </div>

          <div className="card card-details">
            <span className='users-icon'><LuFiles size={20} /> Files</span>
            <div
              className={`file-drop ${isDragging ? 'dragging' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <p>Drag and drop files here, or click the button below to upload.</p>
              <button
                className="choose-files"
                onClick={(e) => {
                  e.stopPropagation(); // <-- This is the key fix
                  fileInputRef.current.click();
                }}
              >
                Choose File (s)
              </button>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>


            <div className="uploaded-files-table">
              {/* The h6 header with the clickable icon. The onClick handler is on the div. */}
              <div className="info-header mb-3 log-toggle-header" onClick={handleToggleFiles}>
                <span className="log-section-header ">
                  <span className='log-title'>
                    Uploaded Files
                  </span>
                  <div className="toggle-icon">
                    {showFilesTable ? <FaAngleUp size={20} /> : <FaAngleDown size={20} />}
                  </div>
                </span>
              </div>

              {/* Conditionally render the table based on the state */}
              {showFilesTable && (
                <>
                  {files && files.length > 0 ? (
                    <div className='uploaded-files-table-2'>
                      <table>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>File Name</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {files.map((file, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="trimmed-cell">
                                {file.length > 40 ? (
                                  <>
                                    {file.slice(0, 40)}... <button onClick={() => alert(file)}>View</button>
                                  </>
                                ) : (
                                  file
                                )}
                              </td>
                              <td className="file-actions">
                                {!file.toLowerCase().endsWith('.zip') && (
                                  <button onClick={() => handlePreview(file)} title="Preview" disabled={!isPreviewable(file)}>
                                    <FiEye size={16} />
                                  </button>
                                )}
                                <button onClick={() => handleDownload(file)} title="Download">
                                  <FiDownload size={16} />
                                </button>
                                <button onClick={() => handleDelete(file)} title="Delete">
                                  <FiTrash2 size={16} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>No files uploaded yet</p>
                  )}
                </>
              )}
            </div>

          </div>


        </div>
      </div>
      {isModalOpen && (
        <EditReferralModal
          section={editSection}
          clientData={client} // your full data object
          onClose={() => setIsModalOpen(false)}
          fetchReferralData={fetchByReferralData}
        />
      )}
      {showModal && (
        <Zohomodel
          onClose={closeModal}
          onCreateReferral={handleCreateReferral}
          onLinkToExistingZoho={handleLinkToZoho}
          zohoData={zohoData}

        />
      )}


    </div>
  );
}

export default ClientDetails;
